<template>
  <v-card class="qb-token-item-card mx-auto py-2" flat color="transparent" min-height="400" max-height="500" v-if="tokenData">
    <div class="qb-token-item-title d-flex align-end">
      <h2 class="pb-0 mb-3">
        <span>{{ tokenTitleArray[0] }}</span><wbr>
        <span v-if="tokenTitleArray[1]">{{ tokenTitleArray[1] }}</span>
      </h2>
    </div>
    <v-img
      :src="tokenData.imageUri || ''"
      aspect-ratio="1"
      :content-class="tokenData.imageUri ? '' : 'd-flex justify-center align-center secondary'"
      :alt="tokenTitleText"
    >
      <v-icon x-large color="black" v-if="!tokenData.imageUri">mdi-image-off</v-icon>
    </v-img>
    <div class="qb-token-item-description my-4">
      <div class="text-left font-weight-medium" v-if="tokenData.description">{{ tokenData.description }}</div>
      <div class="font-italic" v-else-if="tokenData.description === undefined">{{ $t('token.descriptionUnavailable') }}</div>
    </div>
    <div class="py-2">
      <v-btn outlined color="primary" :to="{ name: 'token', params: { token_id: tokenData.tokenId } }">
        {{ $t('token.viewDetails') }}
      </v-btn>
    </div>
  </v-card>
  <v-card outlined class="d-flex justify-center align-center secondary--border h-100" min-height="400" max-height="500" v-else>
    <div class="font-italic secondary--text pa-4">{{ $t('token.dataUnavailable') }}</div>
  </v-card>
</template>

<script>
export default {
  props: {
    tokenData: {
      type: Object,
      default: null
    }
  },
  computed: {
    tokenTitleText () {
      if (!this.tokenData) { return '' }
      return this.tokenData.title || this.$t('token.genericTokenTitle', [this.tokenData.tokenId])
    },
    tokenTitleArray () {
      const tokenTitleArray = this.tokenTitleText.split(' - ')
      if (tokenTitleArray[1]) {
        tokenTitleArray[0] = tokenTitleArray[0] + ' '
        tokenTitleArray[1] = '- ' + tokenTitleArray[1]
      }
      return tokenTitleArray
    }
  }
}
</script>

<style lang="scss">
  @import '@/styles/main.scss';

  .qb-token-item-card {
    max-width: 280px;
    .qb-token-item-title {
      font-weight: 700;
      text-align: left;
      text-transform: none;
      height:60px;
      h2 {
        font-size: 20px;
        max-height: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      @include mdAndDown {
        height: 48px;
        h2 {
          max-height: 48px;
          font-size: 16px;
        }
      }
    }
    .qb-token-item-description {
      height: 42px;
      max-height: 42px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
</style>
